import React from 'react';
import { Tooltips } from '../../tooltips';
import { MultiSpanTable } from '../MultiSpanTable';
export const AMLDetailsTables = ({ sanctions }) => {
    const entries = sanctions.map((sanction, index) => {
        return {
            title: sanction.type.toUpperCase(),
            items: [
                {
                    label: 'Listed Name',
                    value: sanction.name.toUpperCase(),
                    ...(index === 0 && { labelTooltip: Tooltips.ListedNameAML })
                },
                {
                    label: 'Listed Url',
                    value: sanction.url,
                    ...(index === 0 && { labelTooltip: Tooltips.ListedUrlAML })
                },
                {
                    label: 'Listed',
                    value: sanction.dates.start,
                    ...(index === 0 && { labelTooltip: Tooltips.ListedAML })
                },
                {
                    label: 'Listing Ended',
                    value: sanction.dates.end,
                    ...(index === 0 && { labelTooltip: Tooltips.ListingEndedAML })
                }
            ]
        };
    });
    return React.createElement(MultiSpanTable, { entries: entries, header: "Matched Types" });
};
